import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import 'bootstrap/dist/css/bootstrap.min.css';

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import allReducers from "./RootReducers/rootReducers";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./RootSagas/rootSaga";
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from "./Services/keycloak";

const sagaMiddleware = createSagaMiddleware();
let store = createStore(allReducers, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ onLoad: false }}
    >
      <App />
    </ReactKeycloakProvider>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
